import { j as i } from "../../../jsx-runtime-B6kdoens.js";
import { useMergeRefs as c } from "@floating-ui/react";
import { c as g, f as u } from "../../../create-component-CBAeEoQ6.js";
import { a as x } from "../../../TooltipContext-BDAX-u97.js";
const b = g(
  "TooltipTrigger",
  u(
    ({ as: e, children: t, className: r, ...s }, f) => {
      const n = e || "button", o = x(), p = t == null ? void 0 : t.ref, m = c(
        [o.refs.setReference, f, p].filter((a) => !!a)
      );
      return /* @__PURE__ */ i.jsx(
        n,
        {
          className: r,
          type: "button",
          ref: m,
          "data-state": o.open ? "open" : "closed",
          ...o.getReferenceProps(s),
          children: t
        }
      );
    }
  )
);
export {
  b as TooltipTrigger
};
//# sourceMappingURL=index.js.map
